<template>
  <div :class="{'blur-content': isLoading}">
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="Company"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                    {{ $t("companyTxt")+ " " +this.forms.name }} 
                  </h6>
               
                </div>

                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    >
                    
                    </div>
                     
  

                    <div class="row mb-3">
                    
                      <div class="col-lg-12">

                        <div v-if="errors.tax">
                          <div
                            v-for="error in errors"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>


                        <div class="table-responsive pt-3">

                            <table class="table table-bordered">

                                <thead>
                                    <tr class="table-info">
                                        <th>Branch</th>
                                        <th>PPN 10%</th>
                                        <th>PPN 11%</th>
                                        <th>PPN 1.1%</th>
                                        <th>PPN 12%</th>
                                        <th>PPN 2.5%</th>
                                        <th>Auto DPP</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item in detailNsts" :key="item.branch_id">

                                      <td>{{ item.branch_name }}</td>

                                      <td>
                                        <input type="checkbox"
                                          class="form-check-input"
                                          v-model="item.flag_ppn10"
                                          true-value="Y"
                                          false-value="N"
                                        >
                                      </td>

                                      <td>
                                        <input type="checkbox"
                                          class="form-check-input"
                                          v-model="item.flag_ppn11"
                                          true-value="Y"
                                          false-value="N"
                                        >
                                      </td>

                                      <td>
                                        <input type="checkbox"
                                          class="form-check-input"
                                          v-model="item.flag_ppn1_1"
                                          true-value="Y"
                                          false-value="N"
                                        >
                                      </td>

                                      <td>
                                        <input type="checkbox"
                                          class="form-check-input"
                                          v-model="item.flag_ppn12"
                                          true-value="Y"
                                          false-value="N"
                                        >
                                      </td>

                                      <td>
                                        <input type="checkbox"
                                          class="form-check-input"
                                          v-model="item.flag_pph2_5"
                                          true-value="Y"
                                          false-value="N"
                                        >
                                      </td>

                                      <td>
                                        <input type="checkbox"
                                          class="form-check-input"
                                          v-model="item.auto_dpp"
                                          true-value="Y"
                                          false-value="N"
                                        >
                                      </td>

                                      <td> <input type="checkbox"
                                          class="form-check-input"
                                          v-model="item.status"
                                          true-value="Y"
                                          false-value="N"
                                        ></td>

                                    </tr>
                                </tbody>

                            </table>

                            <!-- {{ this.detailNsts }} -->

                        </div>
                         



                      </div>
                    </div>
                   
                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from "@/middleware/mixinAddress.js";

export default {
  name: "CompanyNstRules",
  mixins: [myMixinAddress],
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
        datasNst:[],
        detailNsts:[],
        fetchPostalCode: [],
        fetchCountryCode: [],
        featchProvinceCode: [],
        featchCityCode: [],

        postal_code: [],
        country: [],
        province: [],
        city: [],

        company_type:"",
        permision_role:[],
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        fetchSystemCode:[],
        companyCode: "",
        forms: [],
        userData: "",
        userRole: "",
        fetchTaxOption:[],
        fetchLocRefOption:[],
    };
  },
  watch: {},
  methods: {
   
    
    resetForm() {
      this.forms.code = "";
      this.forms.name = "";
      this.forms.email = "";
      this.forms.sap_code = "";
    },

    backForm() {
      window.location.href = "/company";
    },

    loadData(id) {
      this.isLoading = true;
      const baseURI = this.$settings.endPoint + "company/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        
        this.isLoading = false;
        this.forms = response.data.datas;

        // this.form={ name: 'asep', usernmae:res.username };
      }).catch(error => {

          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }

          this.isLoading = false;

        });
    },

    loadDataNst(id) {
      this.isLoading = true;
      const baseURI = this.$settings.endPoint + "company/detail-nst-rules/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
      

      this.detailNsts = response.data.datas.map(item => ({
        ...item,
        flag_ppn10: item.flag_ppn10 === "Y" ? "Y" : "N",
        flag_ppn11: item.flag_ppn11 === "Y" ? "Y" : "N",
        flag_ppn1_1: item.flag_ppn1_1 === "Y" ? "Y" : "N",
        flag_ppn12: item.flag_ppn12 === "Y" ? "Y" : "N",
        flag_pph2_5: item.flag_pph2_5 === "Y" ? "Y" : "N",
        auto_dpp: item.auto_dpp === "Y" ? "Y" : "N",
        status: item.status === "Y" ? "Y" : "N",
      }));


        // this.form={ name: 'asep', usernmae:res.username };
      }).catch(error => {

          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }

          this.isLoading = false;

        });
    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.userData       = userDatas.sub;
      this.userRole       = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'CompanyController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_update){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    submitData() {
       this.fade(true);
          this.isLoading = true;
          
          // if(typeof this.company_type == "object"){
          //   this.forms.company_type = this.company_type.value
          // }else{
          //   this.forms.company_type = this.company_type
          // }
          // if(this.country){
          //   this.forms.country = this.country.country ? this.country.country : this.country;
          // }else{
          //   this.forms.country = "";
          // }
          // if(this.city){
          //   this.forms.city = this.city.city ? this.city.city : this.city;
          // }else{
          //   this.forms.city = "";
          // }
          // if(this.province){
          //   this.forms.state = this.province.province ? this.province.province : this.province;
          // }else{
          //   this.forms.state = "";
          // }
          // if(this.postal_code){
          //   this.forms.postal_code = this.postal_code.postal_code ? this.postal_code.postal_code : this.postal_code;
          // }else{
          //   this.forms.postal_code = "";
          // }
          const baseURI =
            this.$settings.endPoint + "company/create-nst-rules/" + this.forms.company_id;
          this.$http
            .post(baseURI, this.detailNsts,{ timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                //this.resetForm();
                this.errors = [];
                this.success(response.data.datas.messages);

                //window.history.back();
                var params = this.$onRandom(this.forms.company_id);
                 window.location.href = "/company/nst-rules/" + params + "?status=200&msg=Successfully";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
                this.isLoading = false;
                if(error.code == "ECONNABORTED"){
                  this.error("Please Check Your Internet Connection");
                }
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
              //this.resetForm();
            });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
     
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.loadDataNst(params[0]);
    this.fetchIt();
    
  
  },
};
</script>
<style scoped>
.blur-content{
  filter: blur(5px); 
}
</style>